import { useDataValue } from 'Simple/Data.js'
/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  let id = useDataValue({
    context: 'tx_category_insured',
    viewPath: props.viewPath,
    path: 'insured.insurance_subscription.employer_id',
  })
  return {
    variables: { id },
  }
}
